import { useQuery } from '@tanstack/react-query';

import { BanksApi } from 'api';
import { useUser } from 'hooks/queries';
import { BANK_MARKETPLACE_LEADS_KEY } from '../../keys';

export function useBankMarketplaceLeads({
  shouldNotifyOnChange = true
}: { shouldNotifyOnChange?: boolean } = {}) {
  const banksApi = new BanksApi();
  const { userBankId } = useUser();

  const { data: bankMarketplaceLeads, isLoading: isLoadingBankMarketplaceLeads } = useQuery({
    enabled: !!userBankId,
    queryKey: [BANK_MARKETPLACE_LEADS_KEY, userBankId],
    queryFn: () => banksApi.getMarketplaceLeads(userBankId),
    ...(!shouldNotifyOnChange && { notifyOnChangeProps: [] })
  });

  return {
    bankMarketplaceLeads,
    isLoadingBankMarketplaceLeads
  };
}
